/* Work with us page motion (sections/pp-affiliate-page.liquid, styles in pp-affiliate.css).
   [data-split] headline words rise out of clipped boxes, [data-fade] blocks fade up (data-delay in ms),
   steps draw their connector line, FAQ opens one item at a time, and the application fields write
   themselves into the contact form's message when it is sent. Without JS everything is visible. */
(function () {
  'use strict';
  var root = document.querySelector('.ppf');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function splitWords(el) {
    var index = 0;
    function box(node) {
      var w = document.createElement('span');
      w.className = 'w';
      var inner = document.createElement('span');
      inner.style.setProperty('--i', index++);
      inner.appendChild(node);
      w.appendChild(inner);
      return w;
    }
    Array.prototype.slice.call(el.childNodes).forEach(function (node) {
      if (node.nodeType === 3) {
        var frag = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) frag.appendChild(document.createTextNode(' '));
          else frag.appendChild(box(document.createTextNode(part)));
        });
        el.replaceChild(frag, node);
      }
    });
  }

  function reveal(el, extra) {
    var delay = (extra || 0) + (parseInt(el.getAttribute('data-delay'), 10) || 0);
    setTimeout(function () { el.classList.add('is-in'); }, delay);
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-split]'), splitWords);
  var targets = root.querySelectorAll('[data-split],[data-fade]');
  var hero = root.querySelector('.ppf-hero');
  if (reduce || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        reveal(e.target, 0);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(targets, function (el) {
      if (hero && hero.contains(el)) reveal(el, parseInt(el.getAttribute('data-start'), 10) || 0);
      else io.observe(el);
    });
  }

  /* FAQ */
  var items = root.querySelectorAll('.ppf-acc__item');
  Array.prototype.forEach.call(items, function (item) {
    var head = item.querySelector('.ppf-acc__head');
    head.addEventListener('click', function () {
      var open = !item.classList.contains('is-open');
      Array.prototype.forEach.call(items, function (o) {
        o.classList.remove('is-open');
        o.querySelector('.ppf-acc__head').setAttribute('aria-expanded', 'false');
      });
      if (open) { item.classList.add('is-open'); head.setAttribute('aria-expanded', 'true'); }
    });
  });

  /* Application: underlined fields grow with what is typed, and are written into the message on send */
  var form = root.querySelector('#ppf-form');
  if (form) {
    var lines = form.querySelectorAll('.ppf-line');
    var canvas = document.createElement('canvas').getContext('2d');
    Array.prototype.forEach.call(lines, function (input) {
      var startWidth = 0;
      input.addEventListener('focus', function () { if (!startWidth) startWidth = input.getBoundingClientRect().width; });
      input.addEventListener('input', function () {
        if (window.matchMedia('(max-width: 860px)').matches) return;
        if (!startWidth) startWidth = input.getBoundingClientRect().width;
        var cs = getComputedStyle(input);
        canvas.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
        var need = canvas.measureText(input.value).width + 24;
        input.style.width = Math.max(startWidth, need) + 'px';
      });
    });
    form.addEventListener('submit', function () {
      var rows = [];
      Array.prototype.forEach.call(form.querySelectorAll('[data-key]'), function (f) {
        if (f.value && f.value.trim()) rows.push(f.getAttribute('data-key') + ': ' + f.value.trim());
      });
      var name = form.querySelector('[data-key="Full name"]');
      var email = form.querySelector('[data-key="Email"]');
      form.querySelector('[name="contact[name]"]').value = name ? name.value.trim() : '';
      form.querySelector('[name="contact[email]"]').value = email ? email.value.trim() : '';
      form.querySelector('[name="contact[body]"]').value = 'Partner application\n\n' + rows.join('\n');
    });
  }
})();
